export type Row = Record<string, unknown>;

/**
 * What a migration would change (preview) or did change (a run's undo data),
 * as a plain table. The undo data of a migration is either a list of rows or
 * an object holding lists; both flatten to rows, tagged with the list name.
 */
export const toRows = (data: unknown): Row[] => {
  if (Array.isArray(data)) return data.map((r) => (r && typeof r === 'object' ? (r as Row) : { value: r }));
  if (!data || typeof data !== 'object') return [];
  return Object.entries(data as Row).flatMap(([key, value]) =>
    Array.isArray(value) ? toRows(value).map((r) => ({ list: key, ...r })) : [],
  );
};
